
interface PageHeroProps {
  title: string;
  subtitle?: string;
  image: string;
}

export default function PageHero({ title, subtitle, image }: PageHeroProps) {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden mt-20">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-brown-600/40"></div>
      </div>
      
      <div className="relative z-10 text-center px-6">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl md:text-2xl font-serif text-white/90">
            {subtitle}
          </p>
        )}
        <nav className="mt-6">
          <ol className="flex items-center justify-center space-x-2 text-sm text-white/80 font-serif">
            <li>TOP</li>
            <li>&gt;</li>
            <li>{title}</li>
          </ol>
        </nav>
      </div>
    </section>
  );
}
